(function ( $, window, document, undefined ) {
   "use strict";
   	var Publicar = {

   		mapConfig:null,
        map:null,
   	 	params_visor: {
    		"paramsVisor" : [
				{
					"param": "zoomcontrol",
					"text":"Control de zoom",
					"visor": false,
					"iframe": false
				},
				{
					"param": "openinstamaps",
					"text":"Control d'ampliar el mapa",
					"visor": "disabled",
					"iframe": true
				},
				{
					"param": "homecontrol",
					"text":"Control de tornar a la vista inicial",
					"visor": false,
					"iframe": "disabled"
				},
				{
					"param": "locationcontrol",
					"text":"Control de localització",
					"visor": true,
					"iframe": false
				},
				{
					"param": "sharecontrol",
					"text":"Control de compartir en xarxes socials",
					"visor": false,
					"iframe": false
				},
				{
					"param": "likecontrol",
					"text":"Control de M'agrada",
					"visor": false,
					"iframe": false
				},
				{
					"param": "fonscontrol",
					"text":"Control de fons",
					"visor": true,
					"iframe": true
				},
				{
					"param": "layerscontrol",
					"text":"Control de capes",
					"visor": true,
					"iframe": false
				},
				{
					"param": "control3d",
					"text":"Control de 3D",
					"visor": false,
					"iframe": false
				},
				{
					"param": "snapshotcontrol",
					"text":"Eines d'exportació",
					"visor": true,
					"iframe": false
				},
				{
					"param": "mouseposition",
					"text":"Coordenades del ratolí",
					"visor": false,
					"iframe": false
				},
				{
					"param": "scalecontrol",
					"text":"Control d'escala",
					"visor": false,
					"iframe": false
				},
				{
					"param": "measurecontrol",
					"text":"Control de mesura",
  					"visor": false,
  					"iframe":false
				},
				 {
					"param": "searchcontrol",
					"text":"Control de cerca",
  					"visor": true,
  					"iframe":false
  				},
				{
					"param": "infocontrol",
					"text":"Control d'informació obert",
					"visor": false,
					"iframe":false
				},
				{
					"param": "topbar",
					"text":"Barra superior",
  					"visor": true,
  					"iframe":true
				},				
				{
					"param": "zoomdisplaycontrol",
					"text":"Text nivell de zoom",
  					"visor": false,
  					"iframe":false
					
				},
				{
					"param": "elementmapacontrol" ,
					"text": "Elements del mapa oberts",
					"visor": false,
					"iframe": false
				},
				{
					"param": "exportgpkgcontrol" ,
					"text": "Permetre exportació a Geopackage",
					"visor": true,
					"iframe": false
				},
				{
					"param": "tauladedadescontrol" ,
					"text": "Taula de dades disponible en el visor",
					"visor": true,
					"iframe": true
				}
			]
        },

        init: function() {
        	this.containerId = '#funcio_publicar';
        	//By using the object PROJ you can reference it with "this" (i.e. this.whatever();), easy peazy "namespacing"
        	this.buttonClass = "bt_publicar";
        	this.disabledClass = "bt_publicar_disabled";
        	this.cache();
        	this.subscriptions();
        	this.button;
        	this.bindEvents();

            return this; 
        },

        cache: function(){
        	this.container = $(this.containerId);
        },

        _setMapConfig: function(_mapConfig){
        	this.mapConfig = _mapConfig;
        },

        _setMap: function(map){
        	this.map = map;
        },

        addControl: function(){
        	var self = this;
        	if(arguments[0]){ //container id
        		this.containerId = arguments[0];
        		this.container = $(this.containerId);
        	}

        	if(arguments[1]){ //uid
        		this.uid = arguments[1];
        	}

        	if(arguments[2]){ //collaborateuid
        		this.collaborateuid = arguments[2];
        	}

        	this._addHtmlInterficiePublicar();

        	if(this.collaborateuid){
        		//this._addHtmlInterficiePublicarDisable();
        	}

        	this._addHtmlModalPublicar();
        	this._addHtmlModalIframePublicar();
        	this._addTextDescripcioPublicar();
			
			
        	//require web
        	if (InstamapsUtils.Validator.isRandomUser(this.uid)){
        		this.button.on('click',function(){
        			$('.modal').modal('hide');
        			//$.publish('analyticsEvent',{event:['mapa', tipus_user+'publicar', 'pre-publicar', 1]});

        			$('#dialgo_publicar_random').modal('show');

        			$('#dialgo_publicar_random .bt-sessio').on('click',function(){
        				$(window).off('beforeunload');
        				$(window).off('unload');
        				window.location = paramUrl.loginPage+"?from=mapa";
        			});

        			$('#dialgo_publicar_random .bt_orange').on('click',function(){
        				$(window).off('beforeunload');
        				$(window).off('unload');
        				window.location = paramUrl.registrePage+"?from=mapa";
        			});
        		});
        	}else{
        		//publicar el mapa solo para registrados
        		this.button.on('click',function(){
        			//$.publish('analyticsEvent',{event:['mapa', tipus_user+'bt_desa_publicar', 'modal_publica_mapa', 1]});
        			$.publish('reloadMapConfig','publicar/');
        		});
        	}
        },
 		
 		_setDescriptionColor: function(color)
        {

        	var self = this;
        	$('.note-editable').css('background-color', color.toHexString());

        	if(!self.mapConfig.options)
        		self.mapConfig.options = {};

        	self.mapConfig.options.descriptionColor = color.toHexString();

        },
        
        _updateModalPublicar: function(){
        	//actualizar los campos del dialogo publicar
        	//require utils
        	var self = this;
        	
        	if (InstamapsUtils.Validator.isDefaultMapTitle(self.mapConfig.nomAplicacio)) $('#nomAplicacioPub').val("");
			else $('#nomAplicacioPub').val(self.mapConfig.nomAplicacio);
        	if (self.mapConfig.visibilitat == visibilitat_open){
				$("input[name=publicitat][value=public]").prop('checked', true);
				$("input[name=privacitat][value=obert]").prop('checked', true);
				$('#map_clau').val('');
			}else{
				$("input[name=publicitat][value=privat]").prop('checked', true);
				if (self.mapConfig.clau){
					$("input[name=privacitat][value=restringit]").prop('checked', true);
					$('#map_clau').prop('disabled',true);
					$('#map_clau').val(InstamapsUtils.Getters.randomString(10));
				}else{
					$("input[name=privacitat][value=obert]").prop('checked', true);
					$('#map_clau').prop('disabled',true);
					$('#map_clau').val('');
				}
			}
			
			var backgroundColor = "#fff";
			
			if(self.mapConfig.options){
				$('#optDescripcio').val(self.mapConfig.options.description);
				$('#optTags').val(self.mapConfig.options.tags);
			    $('#optAlies').val(self.mapConfig.options.alies);
				if (self.mapConfig.options.llegenda){
					$('#llegenda_chk').bootstrapSwitch('state', true, true);
					createModalConfigLegend();
				}else{
					$('#llegenda_chk').bootstrapSwitch('state', false, false);
				}
				if (self.mapConfig.options.llegenda){
					//$('#llegendaCompacta').attr("style","display:inline;");
					$('#div_llegenda_chk3').attr("style","display:inline;");
					//$('#div_llegenda_chk2').show();
					/*
					if (self.mapConfig.options.tipusllegenda && self.mapConfig.options.tipusllegenda=="dinamica"){
						$('#llegenda_chk2').bootstrapSwitch('state', true, true);
						$('#txt_llegenda_chk2').html("La llegenda permet a l'usuari seleccionar la capa del seu interès.");
					}
					else {
						$('#llegenda_chk2').bootstrapSwitch('state', false, false);
						$('#txt_llegenda_chk2').html("La llegenda del conjunt de les capes es mostra de manera contínua.");
					}
					*/
					if (!self.mapConfig.options.llegendaOpt){
						$('#llegenda_chk3').bootstrapSwitch('state', false, false);
					}
					else {
						$('#llegenda_chk3').bootstrapSwitch('state', true, true);
					}

				}
				if(self.mapConfig.options.description)
    			{

    			$('#optDescripcio').summernote('code', self.mapConfig.options.description);

    			}
    			
    			if(self.mapConfig.options.descriptionAsAtlas)
    			{
    			
    				$('#cbAtles').prop('checked', self.mapConfig.options.descriptionAsAtlas);

				}
				if (self.mapConfig.options.clonable!=undefined){
					if (self.mapConfig.options.clonable === clonable_no){
						$("input[name=clonable][value=noclonable]").prop('checked', true);
						$("input[name=clonable][value=clonable]").prop('checked', false);
					}else{
						$("input[name=clonable][value=noclonable]").prop('checked', false);
						$("input[name=clonable][value=clonable]").prop('checked', true);
					}
				}
				else {
					$("input[name=clonable][value=noclonable]").prop('checked', true);
					$("input[name=clonable][value=clonable]").prop('checked', false);
				}
				
				
			}
			else {
				$("input[name=clonable][value=noclonable]").prop('checked', true);
				$("input[name=clonable][value=clonable]").prop('checked', false);
			}

			$('input#contextmaps').iCheck({
        	    checkboxClass: 'icheckbox_flat-blue',
        	    radioClass: 'iradio_flat-blue'
			});
			

			if (self.mapConfig!==undefined && self.mapConfig.options!==undefined){
				if (self.mapConfig.options!==null && self.mapConfig.options.contextmaps!==undefined){
					if (self.mapConfig.clau || self.mapConfig.options.contextmaps==="false"){
						$('input#contextmaps').iCheck('uncheck');
					}
					else{
						$('input#contextmaps').iCheck('check');
					}						
				}
				else {
					$('input#contextmaps').iCheck('uncheck');
				}
			}
			else {
				if (self.mapConfig.clau){
					$('input#contextmaps').iCheck('uncheck');
				}
				else{
					$('input#contextmaps').iCheck('check');
				}
			}			

			$('input#contextmaps').on('ifChecked', function(event){
				$('#urlVisorContextMaps').attr("style","display:block;");
			});
		
			$('input#contextmaps').on('ifUnchecked', function(event){
				$('#urlVisorContextMaps').attr("style","display:none;");
			});
			
			$('#div_params_llegenda input').iCheck({
        	    checkboxClass: 'icheckbox_flat-blue',
        	    radioClass: 'iradio_flat-blue'
			});
			
			$('.llegenda-subrow .llegenda-chck').on({
				'ifChecked': function(event){
					window.dataLayer.push({
						'event': 'publicarLlegendaVisor',
						'id': event.target.id
					});
				},
        		'ifUnchecked': function(event){
        			window.dataLayer.push({
						'event': 'publicarLlegendaVisor',
						'id': event.target.id
					});
        		}
			});



			self._createModalConfigDownload();

			self._createModalVisor();

			$('#dialgo_publicar #nomAplicacioPub').removeClass("invalid");
			$( ".text_error" ).remove();
			$('.modal').modal('hide');
			$('#dialgo_publicar').modal('show');
			$('a[href^="#id_info').click();

			if (self.mapConfig.options){
				

				//contacte
				if(self.mapConfig.options.contacte){
					$('#contactePublicar').val(self.mapConfig.options.contacte);
				}

			}
			//escut
			if(self.mapConfig.logo){
				$(".logo").prop('src',"/logos/"+self.mapConfig.logo);
			}
			if(self.mapConfig.logo==""){
				$(".logo").prop('src',"");
			}
			//urlLogo
			if(self.mapConfig && self.mapConfig.options && 
				self.mapConfig.options.urlLogo){
				$('#urlLogo').val(self.mapConfig.options.urlLogo);
			}
			$('#geolocal_tab').attr("style","display:inline");
			
			//Dialeg publicar
			$('#publish-private').tooltip({
				placement : 'bottom',
				container : 'body'
			});
			$('#publish-public').tooltip({
				placement : 'bottom',
				container : 'body'
			});

			//Si mapconfig legend, activat, es mostra
			if(self.mapConfig.options != null && self.mapConfig.options.llegenda){
				//require geocat.legend
				createModalConfigLegend();
				$('#dialgo_publicar .modal-body .modal-legend').show();
			}else{
				//$('#dialgo_publicar .modal-body .modal-legend').hide();
			}
			$('#dialgo_publicar .modal-body .modal-legend').show();
			//$('.legend-subrow-all input').iCheck('check');
			//Traducció dels textos del modal de publicar
    		$('#titlePublicar').text(window.lang.translate($('#titlePublicar').text()));
    		$('#id_info_tab').text(window.lang.translate($('#id_info_tab').text()));
    		$('#id_privacitat_tab').text(window.lang.translate($('#id_privacitat_tab').text()));
    		$('#id_llegenda_tab').text(window.lang.translate($('#id_llegenda_tab').text()));
    		$('#id_reuse_tab').text(window.lang.translate($('#id_reuse_tab').text()));

    		$('#nomAplicacioPub').attr("placeholder", window.lang.translate("Nom"));
		    $('#optDescripcio').attr("placeholder", window.lang.translate("Descripció"));
		    $('#optTags').attr("placeholder", window.lang.translate("Etiquetes"));
		    $('#optAlies').attr("placeholder", window.lang.translate("Àlies de l'usuari (nom públic de l'autor)"));
			$('#publish-warn-text').text(window.lang.translate('El mapa es publicarà amb la vista actual: àrea geogràfica, nivell de zoom i capes visibles'));

		    $('#llegendaTitle').text(window.lang.translate($('#llegendaTitle').text()));
		    $('#textLegend').text(window.lang.translate($('#textLegend').text()));

		    $('#checkObert').text(window.lang.translate($('#checkObert').text()));
		    $('#checkRestringit').text(window.lang.translate($('#checkRestringit').text()));
		    $('#txtPublic').text(window.lang.translate($('#txtPublic').text()));
		    $('#txtPrivat').text(window.lang.translate($('#txtPrivat').text()));
		    $('#checkPublic').text(window.lang.translate($('#checkPublic').text()));
		    $('#checkPrivat').text(window.lang.translate($('#checkPrivat').text()));
		    $('#txtVisible').text(window.lang.translate($('#txtVisible').text()));
		    $('#txtNoVisible').text(window.lang.translate($('#txtNoVisible').text()));
		    $('#resetClau').text(window.lang.translate($('#resetClau').text()));

		    $('#cancelPublicar').text(window.lang.translate($('#cancelPublicar').text()));
		    $('#okPublicar').text(window.lang.translate($('#okPublicar').text()));

		    //$('#txt_llegenda_chk2').text(window.lang.translate($('#txt_llegenda_chk2').text()));
		    $('#publish-legend-yes').text(window.lang.translate($('#publish-legend-yes').text()));
		    $('#publish-legend-tancada').text(window.lang.translate($('#publish-legend-tancada').text()));
		    $('#publish-legend-dinamica').text(window.lang.translate($('#publish-legend-dinamica').text()));
		    $('#publish-legend-estatica').text(window.lang.translate($('#publish-legend-estatica').text()));
		    $('#publish-legend-oberta').text(window.lang.translate($('#publish-legend-oberta').text()));
		    $('#publish-legend-no').text(window.lang.translate($('#publish-legend-no').text()));

		    $('#id_parametres div.visor-name').each(function(){
		    	$(this).text(window.lang.translate($(this).text()));
		    });
		     
			var urlMap ="";
			var nomVisor = self.mapConfig.nom_visor;
			if (nomVisor!=null) {
				nomVisor = nomVisor.replace(self.mapConfig.businessId+"_","");
				urlMap = url('protocol') + "://"+ url('hostname') +"/visor.html?businessid="+ self.mapConfig.businessId;
				urlMap=urlMap+"&3D="+estatMapa3D;
			} else {
				var nomApp = $('#dialgo_publicar #nomAplicacioPub').val();
			 	var nomIndexacio=nomApp;
        		if (nomIndexacio!=undefined) {
					(nomIndexacio.length > 100)?nomIndexacio=nomIndexacio.substring(0,100):nomIndexacio;
					nomIndexacio= encodeURI(nomIndexacio);
				}

	        	urlMap = self._getUrlMap();
	
	        	urlMap = urlMap.replace('mapa','visor');
				urlMap = urlMap.replace('#no-back-button','');
				urlMap=urlMap+"&3D="+estatMapa3D;

			}
			if(isSostenibilitatUser(false)){				
				urlMap=urlMap +"&appmodul=sostenibilitat";			
			}
															  
			$("#urlVisorMap a").attr("href", urlMap);
			$("#urlVisorContextMaps a").attr("href",  InstamapsUtils.UrlUtils.getContextMapsUrl(urlMap));
			if ($('input#contextmaps')[0].checked) {
				$("#urlVisorContextMaps").attr("style","display:block;");
			}
			else {
				$("#urlVisorContextMaps").attr("style","display:none;");
			}
			$('#urlMap').val(urlMap);
			var embedUrl = urlMap+'&embed=1';
			if (urlMap.indexOf("?")==-1)  embedUrl = urlMap+'?embed=1';
			//$('#iframeMap').val('<div style="height: 75vh; width: 90vw; margin: auto;"><iframe width="640" height="480" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="'+embedUrl+'"></iframe></div>');
			$('#iframeMap').val(InstamapsUtils.Dom.createIframeHtml(embedUrl));

			$("#publish-form-error").hide();

			$('a[href^="#id_info').click();
		},

        _addHtmlInterficiePublicar: function(){
        	var txtBoto="";
        	if (mapConfig.bloquejat!=undefined && mapConfig.bloquejat!=''  && mapConfig.bloquejat!='[{}]'
        		&& mapConfig.bloquejat!='N' && mapConfig.bloquejat!='[{"bloquejat":"N"}]' && mapConfig.bloquejat!='[{"uid":null,"bloquejat":null}]'){
        		txtBoto="Desar / Desbloquejar";
        	}
        	else{
        		txtBoto="Desar / Publicar el mapa";
        	}
        	this.container.append(
    			'<div class="'+this.buttonClass+'" data-toggle="tooltip" data-lang-title="Desa\'l i decideix si fer-lo públic o privat" title="Desa\'l i decideix si fer-lo públic o privat">'+
    			'<span lang="ca">'+txtBoto+'</span>'+
    			'</div>'
    		);

        	this.button = $('.'+this.buttonClass);

        	this.button.tooltip({
        		placement : 'right',
        		container : 'body'
        	});
        },

        _addHtmlInterficiePublicarDisable: function(){
        	this.container.children().removeClass(this.buttonClass).addClass(this.disabledClass);
        },

        _addHtmlModalPublicar: function(){
        	var self = this;
        	$.get("/static/geocatweb/templates/modalPublicar.html",function(data){
        		//TODO ver como pasar el modal container
        		$('#mapa_modals').append(data);

        		$('.make-switch').bootstrapSwitch();
            	//Configurar Llegenda
            	//require geocat.legend
				createModalConfigLegend();
				$('#dialgo_publicar .modal-body .modal-legend').show();
				$('.legend-subrow-all input').iCheck('check');
				$('.llegenda-subrow input#visor-chck-dinamic').iCheck('check');					
				$('.llegenda-subrow input#visor-chck-oberta').iCheck('check');	
				$('.llegenda-subrow input#iframe-chck-compacta').iCheck('check');	
            	//mostrar el checkbox de triar tipus de llegenda
            	//$('#div_llegenda_chk2').attr("style","display:block;");
            	//$('#llegenda_chk2').bootstrapSwitch('state', true, true);
				//$('#llegendaCompacta').attr("style","display:inline;");
				$('#div_llegenda_chk3').attr("style","display:inline;");
            	$('#llegenda_chk3').bootstrapSwitch('state', true, true);
            		
            	if (self.mapConfig!=undefined && (self.mapConfig.options==null || (self.mapConfig.options!=null && !self.mapConfig.options.llegenda))) {
            		//Per defecte seleccionem tots si es selecciona que es vol llegenda
					$('.legend-subrow-all input').iCheck('check');
            	}
            		
				

				
           	 	$('input:radio[name="privacitat"]').change(function() {
					if ($(this).val() == 'obert') {
						if (self.mapConfig.clau){
							$('#map_clau').val('');
						}else{
							$('#map_clau').prop('disabled',true);
							$('input#contextmaps').prop('disabled',false);
							$('input#contextmaps').iCheck('check');
						}
					} else {
						if (self.mapConfig.clau){
							$('#map_clau').val(InstamapsUtils.Getters.randomString(10));
							$('#map_clau').prop('disabled',true);
							$('input#contextmaps').prop('disabled',false);
							$('input#contextmaps').iCheck('check');
						}else{
							$('#map_clau').prop('disabled',false);
							$('input#contextmaps').iCheck('uncheck');
							$('input#contextmaps').prop('disabled',true);
							
						}
					}
            	});

            	$('#resetClau').on('click',function(){
             		var mapData = {
             			businessId: self.mapConfig.businessId,
             			uid: self.uid
             		};
             		//require ajax
             		resetClauMapa(mapData).then(function(results){
             			self.mapConfig.clau = null;
             			$('#map_clau').val('');
             		});
             	});
            	//require dropzone
    			$('#file-logo').dropzone({
    			    url: paramUrl.uploadLogo,
    			    maxFilesize: 100,
    			    maxFiles: 1,
    			    paramName: "uploadfile",
    			    maxThumbnailFilesize: 1,
    			    acceptedFiles: 'image/*',
    			    dictDefaultMessage: "<span lang='ca'>Arrossega aquí la teva imatge del teu escut o logo (màx 132x50 px)</span>",
    			    init: function() {
    			      var myDropZone = this;
    			      this.on('success', function(file, json) {
    			    	  myDropZone.removeAllFiles();
    			    	  $(".logo").prop('src',"/logos/"+json.filePath+"?"+ + (+new Date()));
    			      });
    			      this.on('addedfile', function(file) {
    			    	  this.options.url = paramUrl.uploadLogo+"businessId="+self.mapConfig.businessId;
    			      });
    			    }
    			});

    		    $('#dialgo_publicar .btn-primary').on('click',function(){
    				self._loadPublicarData(false);
    			});
    			
    			$('#optDescripcio').summernote({
    				lang: 'ca-ES',
    				toolbar: [
    					['font', ['color', 'bold', 'italic', 'underline', 'fontname', 'fontsize']],
    					['paragraph', ['ol', 'ul', 'paragraph']],
    					['style', ['table', 'link', 'hr']],
    					['insert', ['picture', 'video']],
    					['extra', ['codeview', 'fullscreen', 'undo', 'redo']]
    				],
    				dialogsInBody: true,
    				disableDragAndDrop: true,
    				height: 200
    			});
    			
    			$('.note-group-select-from-files').hide();	//Hide the file chooser

        	});

        	$.get("/static/geocatweb/templates/modalPublicarRandom.html",function(data){
        		//TODO ver como pasar el modal container
        		$('#mapa_modals').append(data);
        	});

        },

        _addHtmlModalIframePublicar: function(){
        	$.get("/static/geocatweb/templates/modalIframePublicar.html",function(data){
        		//TODO ver como pasar el modal container
        		$('#mapa_modals').append(data);
        	});
		},
		
		_addTextDescripcioPublicar: function(){
        	$.get("/static/geocatweb/templates/textDescripcioMapa.html",function(data){
        		//TODO ver como pasar el modal container
				$('#optDescripcio').summernote('code', data);
        	});
        },

        _getUrlMap: function(){
			return InstamapsUtils.Getters.getUrlMapa(window, Cookies, DOMINI, url('?id'));
        },

        _addShareButtons: function(){
        	var self = this;
        	$('#socialSharePublicar').html('');
        	var v_url = self._getUrlMap();
        	
			var nomVisor = self.mapConfig.nom_visor;
			if (nomVisor!=null) {
				nomVisor = nomVisor.replace(self.mapConfig.businessId+"_","");
				v_url = url('protocol') + "://"+ url('hostname') +"/visor.html?businessid="+ self.mapConfig.businessId;
				v_url= v_url+"&3D="+estatMapa3D;
			}
        	
        	if (v_url.indexOf("mapacolaboratiu=si")>-1) v_url=v_url.replace("&mapacolaboratiu=si","");
			
			if(isSostenibilitatUser(false)){				
				v_url=v_url +"&appmodul=sostenibilitat";			
			}				  
			
			//require share
			$('#socialSharePublicar').share({
				networks: ['email','facebook','googleplus','twitter','linkedin','pinterest'],
				theme: 'square',
				urlToShare: v_url
			});

			$('#socialSharePublicar .pop-social').on('click', function(event){
				//$.publish('analyticsEvent',{event:['mapa', '1#compartir-publicar', $(this).attr('data-type'), 1]});
				window.open($(this).attr('href'),'t','toolbar=0,resizable=1,status=0,width=640,height=528');
				return false;
			});

        },

        _updateDownloadableData: function(){
        	var downloadableDataPub = {};
        	$(".downloadable-subrow").each(function(index,element){
        		var businessId = $(element).attr('data-businessid');
        		var obj = {
    				chck : $(element).children( "div.icheckbox_flat-blue").hasClass('checked'),
    				businessId : businessId
        		};
        		if(downloadableDataPub[businessId]){
        			downloadableDataPub[businessId] = [];
        		}
        		if(!downloadableDataPub[businessId]){
        			downloadableDataPub[businessId] = [];
        		}
        		downloadableDataPub[businessId].push(obj);
        	});
        	this.downloadableData = downloadableDataPub;
        	downloadableData = downloadableDataPub;
        },

        _loadPublicarData: function(fromCompartir){

        	this.fromCompartir = fromCompartir;
        	//requiere utils
        	if(!fromCompartir){//Si no venim de compartir, fem validacions del dialeg de publicar
        		if(InstamapsUtils.Validator.isBlank($('#dialgo_publicar #nomAplicacioPub').val())){
        			$('#dialgo_publicar #nomAplicacioPub').addClass("invalid");
        			$('#dialgo_publicar #nomAplicacioPub').nextAll('.text_error').remove();
        			$('#dialgo_publicar #nomAplicacioPub').after("<span class=\"text_error\" lang=\"ca\">"+window.lang.translate('El camp no pot estar buit')+"</span>");
        			$("#publish-form-error").show();
        			return false;
        		}else if(InstamapsUtils.Validator.isDefaultMapTitle($('#dialgo_publicar #nomAplicacioPub').val())){
        			$('#dialgo_publicar #nomAplicacioPub').addClass("invalid");
        			$('#dialgo_publicar #nomAplicacioPub').nextAll('.text_error').remove();
        			$('#dialgo_publicar #nomAplicacioPub').after("<span class=\"text_error\" lang=\"ca\">"+window.lang.translate("Introdueix un nom vàlid per a la publicació del mapa")+"</span>");
        			$("#publish-form-error").show();
        			return false;
        		}
        	}

        	$("#publish-form-error").hide();
        	$.publish('getMap','publicar/');
        },

        _publicarMapa: function(){

     		//$.publish('analyticsEvent',{event:['mapa', '1#bt_publicar', 'publicar_mapa', 10]});
        	var self = this;
        	var options = {};
        	var _map = this.map;
			options.tags = $('#dialgo_publicar #optTags').val();			
			options.description = $('#dialgo_publicar #optDescripcio').summernote('code');
			if (options.description.indexOf("En aquest apartat pots escriure la")>-1) options.description="";
        	options.alies = $('#dialgo_publicar #optAlies').val();

			options.mapa3D=estatMapa3D;
			if(estatMapa3D){
				disparaEventMapa=false;
				mapaEstatNOPublicacio=false;
				mapaVista3D.getPosicioCamera3D().then(function (cameraPos) {
				options.camera3D=cameraPos;
				});

				mapaVista3D.retornaPosicio2D().then(function (bbox) {
					options.center = bbox.centerLat+","+bbox.centerLng;
					options.zoom = bbox.zoomLevel;
					options.bbox = bbox.lng0+","+bbox.lat0+","+bbox.lng1+","+bbox.lat1;
				});

			}else{
				options.center = _map.getCenter().lat+","+_map.getCenter().lng;
				options.zoom = _map.getZoom();
				options.bbox = _map.getBounds().toBBoxString();
			}

			var logo = null;
			//Fijar valores al quitar las opciones del dialogo.
			options.fontType = 'Arial';
			options.textColor = '#444444';
			options.barColor = "#fff";
			/*
			options.fontType = $('.bfh-selectbox input[type=hidden]').val();
			options.textColor = rgb2hex($('#dv_color_text_bar').css('background-color'));
			options.barColor = rgb2hex($('#dv_fill_menu_bar').css('background-color'));
			*/
			options.contacte = $('#contactePublicar').val();
			if($(".logo").prop('src') != '/static/geocatweb/css/images/blank.gif'){
				logo = $(".logo").prop('src').match(/([\w\d_-]*)\.?[^\\\/]*$/i)[0];
				if(logo.indexOf('?') != -1){
					logo = logo.substring(0,logo.indexOf('?'));
				}
			}
        	
        	var visibilitat = visibilitat_open;

        	if ($("input[name=publicitat]:checked").val()=="public"){
        		visibilitat = visibilitat_open;
        	}else{
        		visibilitat = visibilitat_privat;
			}
			
			var clonable = clonable_no;

        	if ($("input[name=clonable]:checked").val()=="noclonable"){
        		clonable = clonable_no;
        	}else{
        		clonable = clonable_si;
        	}			

			options.clonable = clonable;

        	//TODO de los botones ver nuevos botones
        	options.llegenda = $('#llegenda_chk').bootstrapSwitch('state');

        	if ($('#llegenda_chk2').bootstrapSwitch('state')){
        		options.tipusllegenda="dinamica";
        	}
        	else{
        		options.tipusllegenda="estatica";
        	}

        	options.llegendaOpt = $('#llegenda_chk3').bootstrapSwitch('state');

        	if(options.llegenda){
        		//TODO funcion en el modulo
        		//require geocat.legend
        		updateMapLegendData();
        	}else{
        		mapLegend = {};
        	}

        	//Revisio de capes amb permis de descarrega
        	//console.debug(this.downloadableData);
        	this._updateDownloadableData();
        	//console.debug(this.downloadableData);

        	//Revisamos los parametros del visor e iframe
        	this._updateParamsData();

        	options.layers = true;
        	options.social = true;
        	options.fons = _map.getActiveMap();
        	options.fonsColor = _map.getMapColor();
        	options.idusr = Cookies.get('userId');
        	//Issue #467: S'ha de respectar el que es selecciona al publicar sobre si una capa és descarregable o no.
        	options.downloadable = this.downloadableData;
        	options.params = this.paramsData;
   
			if(isSostenibilitatUser(false)){
				try{
					if(self.mapConfig.options && self.mapConfig.options.sostenibilitat){
						options.sostenibilitat=self.mapConfig.options.sostenibilitat;
					}
				}catch(Err){
					console.log(Err);
				}					
			}					   
	
			var newMap = false;

        	var layers = $(".leaflet-control-layers-selector").map(function(){
        		return {businessId: this.id.replace('input-',''), activa: $(this).is(':checked')};
        	}).get();

  			//$.publish('analyticsEvent',{event:['mapa', '1#num_capes_publicades', layers.length, 10]});

        	//Atencio miro estat de les capes
        	//reOrderGroupsAndLayers(true);

        	var nomApp = $('#nomAplicacio').html();

        	if(!self.fromCompartir) nomApp = $('#dialgo_publicar #nomAplicacioPub').val();
        	
        	nomApp = nomApp.replaceAll("/","_");

        	var nomIndexacio=nomApp;
			if (nomIndexacio!=undefined){
				(nomIndexacio.length > 100)?nomIndexacio=nomIndexacio.substring(0,100):nomIndexacio;
				nomIndexacio= encodeURI(nomIndexacio);
			}

			var urlMap;
			var nomVisor = self.mapConfig.nom_visor;
			if (nomVisor!=null) {
				nomVisor = nomVisor.replace(self.mapConfig.businessId+"_","");
				urlMap = url('protocol') + "://"+ url('hostname') +"/visor.html?businessid="+ self.mapConfig.businessId;
				urlMap=urlMap+"&3D="+estatMapa3D;
			} else {

				urlMap = self._getUrlMap();
				urlMap=urlMap+"&title="+nomIndexacio;

				urlMap = urlMap.replace('mapa','visor');
				urlMap = urlMap.replace('#no-back-button','');
				urlMap=urlMap+"&3D="+estatMapa3D;

			}
        	$("#urlVisorMap a").attr("href", urlMap);
			$("#urlVisorContextMaps a").attr("href",  InstamapsUtils.UrlUtils.getContextMapsUrl(urlMap));
			if ($('input#contextmaps')[0].checked) {
				$("#urlVisorContextMaps").attr("style","display:block;");
			}
			else {
				$("#urlVisorContextMaps").attr("style","display:none;");
			}
        	$('#urlMap').val(urlMap);
        	var embedUrl = urlMap+'&embed=1';
			if (urlMap.indexOf("?")==-1)  embedUrl = urlMap+'?embed=1';
			//$('#iframeMap').val('<div style="height: 75vh; width: 90vw; margin: auto;"><iframe width="640" height="480" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="'+embedUrl+'" ></iframe></div>');
			$('#iframeMap').val(InstamapsUtils.Dom.createIframeHtml(embedUrl));

			//console.info(mapLegend);

        	if ($("input[name=treureLogo]:checked").val()){
        		logo="";
        	}
        	
        	var urlLogo="";
        	if ($('#urlLogo').val()!=""){
        		options.urlLogo=$('#urlLogo').val();
			}
			
			if (isEuroregioUser()){
				options.urlLogo = "/static/img/logo_EPM.jpg";
				logo = "/static/img/logo_EPM.jpg";
			}

			//opció de veure a contextmaps
			options.contextmaps = ""+$('input#contextmaps')[0].checked+"";
			        	
        	options = JSON.stringify(options);
        	
        	var data = {
        		nom: nomApp, //jQuery('#dialgo_publicar #nomAplicacio').val(),
        		uid: self.uid,
        		visibilitat: visibilitat,
        		tipusApp: 'vis',
        		options: options,
        		logo: logo,
        		legend: JSON.stringify(mapLegend),
        		layers: JSON.stringify(layers)
        	};

        	//Enregistrem tipus de fons i visibilitat
        	//$.publish('analyticsEvent',{event:['mapa', tipus_user+'publicar', visibilitat+"#"+_map.options.typeMap, 1]});

        	//crear los archivos en disco
        	var layersId = getBusinessIdOrigenLayers();
        	var trafficLightKeys = getTrafficLightKeys();
        	var laydata = {
        		uid: self.uid,
        		servidorWMSbusinessId: layersId,
        		trafficLightValues: trafficLightKeys,
        		businessId: self.mapConfig.businessId
        	};
        	//require ajax
        	publicarCapesMapa(laydata);

        	//Captura Map per la Galeria
        	//require geocat.canvas
        	capturaPantalla(CAPTURA_GALERIA, mapConfig);
        	this.createWMSFromMap();

        	if(!self.mapConfig.clau){
        		if ($("input[name=privacitat]:checked").val()=="restringit"){
					if($.trim($('#map_clau').val()) != ""){
        				data.clauVisor = $.trim($('#map_clau').val());
        			}
        		}
        		this._callPublicarMapa(data, newMap, self.fromCompartir);
        	}else{
        		if($("input[name=privacitat]:checked").val()=="obert" || visibilitat == visibilitat_open){
					var mapData = {
        				businessId: self.mapConfig.businessId,
        				uid: self.uid
        			};
        			//require ajax
        			resetClauMapa(mapData).then(function(results){
        				self.mapConfig.clau = null;
        				$('#map_clau').val('');
        				self._callPublicarMapa(data, newMap, self.fromCompartir);
        			});
        		}else{
        			self._callPublicarMapa(data, newMap, self.fromCompartir);
        		}
        	}

        	$("#publish-form-error").hide();

        },

        _callPublicarMapa: function(data, newMap, fromCompartir){
        	var self = this;

        	if (newMap){
        		//require ajax
        		createMap(data).then(function(results){
        			if (results.status == "ERROR"){
        		  		//$.publish('analyticsEvent',{event:['error', 'publicar_mapa', 'tipusPub_error', 10]});
						window.dataLayer.push({
							'event': 'publicarMapaKO',
							'businessId': self.mapConfig.businessId,
							'uid':self.uid 
						});
              			$("input[name=privacitat]:checked").val();
        			}else{
						window.dataLayer.push({
							'event': 'publicarMapaOK',
							'businessId': self.mapConfig.businessId,
							'uid':self.uid 
						});

        				var _mapConfig = results.results;
        				_mapConfig.options = $.parseJSON( _mapConfig.options );
        				_mapConfig.newMap = false;
        				self._setMapConfig(_mapConfig);

        				$.publish('updateMapConfig', _mapConfig);

        				var mapData = {
        					businessId: self.mapConfig.businessId,
        					uid: self.uid
        				};
        				//require ajax
        				publicarMapConfig(mapData).then(function(results){
							
        				});

        				//$('#businessId').val(self.mapConfig.businessId);
        			}
        		});
        	}else{
				//data.businessId = $('#businessId').val();
				data.businessId = self.mapConfig.businessId;				
        		//require ajax
			    updateMap(data).then(function(results){
        			if (results.status == "ERROR"){
						//TODO Mensaje de error
						window.dataLayer.push({
							'event': 'publicarMapaKO',
							'businessId': self.mapConfig.businessId,
							'uid':self.uid 
						});
        			}else{
						window.dataLayer.push({
							'event': 'publicarMapaOK',
							'businessId': self.mapConfig.businessId,
							'uid':self.uid 
						});

						var _mapConfig = results.results;
						if (typeof _mapConfig.options === 'object') {
							_mapConfig.options = _mapConfig.options;
						}
						else {
							_mapConfig.options = $.parseJSON( _mapConfig.options );
						}
        			
        				_mapConfig.newMap = false;
        				self._setMapConfig(_mapConfig);

        				$.publish('updateMapConfig', _mapConfig);

        				var mapData = {
        					businessId: self.mapConfig.businessId,
        					uid: self.uid
        				};

        				//require ajax
        				publicarMapConfig(mapData).then(function(results){
							//createModalConfigLegend();
        					self.mapConfig.nom_visor = results.results.nom_visor;
        					var urlMap ="";
							var nomVisor = self.mapConfig.nom_visor;
	
							if (nomVisor!=null) {
								nomVisor = nomVisor.replace(self.mapConfig.businessId+"_","");
								urlMap = url('protocol') + "://"+ url('hostname') +"/visor.html?businessid="+ self.mapConfig.businessId;
								urlMap=urlMap+"&3D="+estatMapa3D;
							}
							else {

								urlMap = self._getUrlMap();
					
								urlMap = urlMap.replace('mapa','visor');
								urlMap = urlMap.replace('#no-back-button','');
								urlMap=urlMap+"&3D="+estatMapa3D;

							}
        					
							if(isSostenibilitatUser(false)){				
								urlMap=urlMap +"&appmodul=sostenibilitat";			
							}

							$("#urlVisorMap a").attr("href", urlMap);
							$("#urlVisorContextMaps a").attr("href",  InstamapsUtils.UrlUtils.getContextMapsUrl(urlMap));
							if ($('input#contextmaps')[0].checked) {
								$("#urlVisorContextMaps").attr("style","display:block;");
							}
							else {
								$("#urlVisorContextMaps").attr("style","display:none;");
							}
        					$('#urlMap').val(urlMap);
        					var embedUrl = urlMap+'&embed=1';
        					if (urlMap.indexOf("?")==-1)  embedUrl = urlMap+'?embed=1';
							//$('#iframeMap').val('<div style="height: 75vh; width: 90vw; margin: auto;"><iframe width="640" height="480" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="'+embedUrl+'" ></iframe></div>');
							$('#iframeMap').val(InstamapsUtils.Dom.createIframeHtml(embedUrl));

        					var txtPubBoto = $('.bt_publicar>span').html();
        					if (typeof mapConfig.bloquejat == "string" && mapConfig.bloquejat.indexOf("bloquejat")>-1 && mapConfig.bloquejat.indexOf("null")==-1) {
        						var bloquejatJson=$.parseJSON(mapConfig.bloquejat);
        						jQuery.map( bloquejatJson, function( val, i ) {
									if (val.bloquejat==="S") {
										InstamapsUtils.Mapa.treureBloqueigMapa(jQuery, url, Cookies, lockController, runningActions, desbloquejarMapa).then(function(){
											$('#dialgo_publicar').modal('hide');
											//update map name en el control de capas
											$('#nomAplicacio').text(self.mapConfig.nomAplicacio);
											$('#nomAplicacio').editable('setValue', self.mapConfig.nomAplicacio);
											$('#dialgo_url_iframe').modal('show');
											self._addShareButtons();

											jQuery('#dialgo_url_iframe').on('hidden.bs.modal', function (e) {
												if(estatMapa3D){
													disparaEventMapa=true;
													mapaEstatNOPublicacio=true;
												}
											});
										});
									}
        						});
        					}
        					else {
        						if(!fromCompartir){
                					$('#dialgo_publicar').modal('hide');
                					//update map name en el control de capas
                					$('#nomAplicacio').text(self.mapConfig.nomAplicacio);
                					$('#nomAplicacio').editable('setValue', self.mapConfig.nomAplicacio);
                					$('#dialgo_url_iframe').modal('show');
                					self._addShareButtons();

        							jQuery('#dialgo_url_iframe').on('hidden.bs.modal', function (e) {
        								if(estatMapa3D){
        									disparaEventMapa=true;
        									mapaEstatNOPublicacio=true;
        								}
        							});
        						}
        					}
        				});

        			}
        		});
        	}
        },

        _createModalConfigDownload: function(){
        	var count = 0;
        	var html = window.lang.translate('Escull les capes de dades que els altres usuaris d\'Instamaps podran baixar-se i reutilitzar')+'<br/><br/>';
        	html += '<label class="control-label" lang="ca">'+
        		window.lang.translate('Capes reutilitzables pels altres usuaris:')+
        		'</label>&nbsp;<span class="glyphicon glyphicon-download-alt"></span>';

        	html += '<div id="div_downloadable">'+
        			'<div class="separate-downloadable-row-all"></div>'+
        			'<div class="downloadable-subrow-all">'+
        			'<div class="col-md-9 downloadable-name-all">'+
        				window.lang.translate('Totes')+
        			'</div>'+
        			'<input id="downloadable-chck-all" class="col-md-1 download-chck" type="checkbox">'+
        			'</div>';
        	html += '<div class="separate-downloadable-row-all"></div>';

        	$.each(controlCapes._layers, function(i, item){
        		var layer = item.layer;
        		var layerName = layer.options.nom;
        		var checked = "";

        		var tipusLayer = "";
        		if(layer.options.tipus) tipusLayer = layer.options.tipus;
        		//Si no es WMS
        		if(tipusLayer.indexOf(t_wms)== -1){
        			//Si té checkec definit
        			if(downloadableData[layer.options.businessId]){
        				if(downloadableData[layer.options.businessId][0].chck) {
        					checked = 'checked="checked"';
        				}
        			}else{//Sino per defecte check
        				checked = '';
        			}

        			html += '<div class="downloadable-subrow" data-businessid="'+layer.options.businessId+'">'+
        						'<div class="col-md-9 downloadable-name">'+
        							layerName+
        						'</div>'+
        						'<input id="downloadable-chck" class="col-md-1 downloadable-chck" type="checkbox" '+checked+' >'+
        					'</div>';
        			html+='<div class="separate-downloadable-row"></div>';
        		}
        	});

        	$('#dialgo_publicar #id_reuse').html(html);

        	$('#div_downloadable input').iCheck({
        	    checkboxClass: 'icheckbox_flat-blue',
        	    radioClass: 'iradio_flat-blue'
        	});

        	$('.downloadable-subrow-all input').on({
        		'ifChecked': function(event){
        			$('.downloadable-subrow input').iCheck('check');
        		},
        		'ifUnchecked': function(event){
        			$('.downloadable-subrow input').iCheck('uncheck');
        		}
        	});
        },

        _createModalVisor: function(){
        	var self = this,
        	count = 0,
        	html = "";

			var source = $("#list-parameter-fields").html();
			
			Handlebars.registerHelper('checkbox', function(options, class_s, id, type) {
				var chck = "";
				if("disabled" === options){
					chck = "<input name='"+class_s+"' id='"+id+"_"+type+"' class='"+class_s+"' type='checkbox' disabled>";
				}else if(options){
					chck = "<input name='"+class_s+"' id='"+id+"_"+type+"' class='"+class_s+"' type='checkbox' checked>";
				}else{
					chck = "<input name='"+class_s+"' id='"+id+"_"+type+"' class='"+class_s+"' type='checkbox'>";
				}
				return new Handlebars.SafeString(chck);
			});
			
        	var template = Handlebars.compile(source);
        	html = template(self.params_visor);

        	$('#dialgo_publicar .list-parameters').html(html);

        	$('#div_params_visor input').iCheck({
        	    checkboxClass: 'icheckbox_flat-blue',
        	    radioClass: 'iradio_flat-blue'
        	});

			$('.visor-subrow .visor-chck').on({
				'ifChecked': function(event){
					window.dataLayer.push({
						'event': 'publicarAddVisorParams',
						'id': event.target.id
					});
				},
        		'ifUnchecked': function(event){
        			window.dataLayer.push({
						'event': 'publicarRemoveVisorParams',
						'id': event.target.id
					});
        		}
			});

			$('.visor-subrow .iframe-chck').on({
				'ifChecked': function(event){
					window.dataLayer.push({
						'event': 'publicarAddIframeParams',
						'id': event.target.id
					});
				},
        		'ifUnchecked': function(event){
        			window.dataLayer.push({
						'event': 'publicarRemoveIframeParams',
						'id': event.target.id
					});
        		}
			});

        	self._loadConfigParams();

        	$('.visor-subrow-all #visor-chck-all').on({
        		'ifChecked': function(event){
        			$('.visor-subrow .visor-chck').iCheck('check');
        		},
        		'ifUnchecked': function(event){
        			$('.visor-subrow .visor-chck').iCheck('uncheck');
        		}
        	});

        	$('.visor-subrow-all #iframe-chck-all').on({
        		'ifChecked': function(event){
        			$('.visor-subrow .iframe-chck').iCheck('check');
        		},
        		'ifUnchecked': function(event){
        			$('.visor-subrow .iframe-chck').iCheck('uncheck');
        		}
        	});
        },

        _updateParamsData: function(){
        	var self = this;
        	var paramsDataPub = {iframe:{}, visor:{}};

        	$('.col-visor div.icheckbox_flat-blue').map(function(){
        		var _$this = $(this);
        		var paramname = _$this.closest( ".visor-subrow" ).data('param');
        		if(_$this.hasClass('checked')){
        			paramsDataPub.visor[paramname] = 1;
        		}else{
        			paramsDataPub.visor[paramname] = 0;
        		}
        	});

        	$('.col-iframe div.icheckbox_flat-blue').map(function(){
        		var _$this = $(this);
        		var paramname = _$this.closest( ".visor-subrow" ).data('param');
        		if(_$this.hasClass('checked')){
        			paramsDataPub.iframe[paramname] = 1;
        		}else{
        			paramsDataPub.iframe[paramname] = 0;
        		}
			});
			
			if (!$('.llegenda-subrow input#visor-chck-dinamic').parent().hasClass('checked')){
				paramsDataPub.visor["llegendadinamica"] = 0;
			}
			else {
				paramsDataPub.visor["llegendadinamica"] = 1;
			}

			if (!$('.llegenda-subrow input#iframe-chck-dinamic').parent().hasClass('checked')){
				paramsDataPub.iframe["llegendadinamica"] = 0;
			}
			else {
				paramsDataPub.iframe["llegendadinamica"] = 1;
			}

			if (!$('.llegenda-subrow input#visor-chck-oberta').parent().hasClass('checked')){
				paramsDataPub.visor["llegendaoberta"] = 0;
			}
			else {
				paramsDataPub.visor["llegendaoberta"] = 1;
			}

			if (!$('.llegenda-subrow input#iframe-chck-oberta').parent().hasClass('checked')){
				paramsDataPub.iframe["llegendaoberta"] = 0;
			}
			else {
				paramsDataPub.iframe["llegendaoberta"] = 1;
			}

			if (!$('.llegenda-subrow input#visor-chck-compacta').parent().hasClass('checked')){
				paramsDataPub.visor["legendControl"] = 0;
			}
			else {
				paramsDataPub.visor["legendControl"] = 1;
			}

			if (!$('.llegenda-subrow input#iframe-chck-compacta').parent().hasClass('checked')){
				paramsDataPub.iframe["legendControl"] = 0;
			}
			else {
				paramsDataPub.iframe["legendControl"] = 1;
			}
			
        	self.paramsData = paramsDataPub;
        },

        _loadConfigParams: function(){
        	var self = this,
        	_mapConfig = self.mapConfig;
        	if(_mapConfig.options!=null && _mapConfig.options.params){
        		var params = _mapConfig.options.params;
        		if(!$.isEmptyObject(params.visor)){
        			var visor = params.visor;
        			$.each(visor, function(key, value){
						if (key==="legendControl"){
							if(value === 1){
								$('.llegenda-subrow input#visor-chck-compacta').iCheck('check');
							}else{
								$('.llegenda-subrow input#visor-chck-compacta').iCheck('uncheck');
							}
						}
						else if (key==="llegendadinamica"){
							if(value === 1){
								$('.llegenda-subrow input#visor-chck-dinamic').iCheck('check');
							}else{
								$('.llegenda-subrow input#visor-chck-dinamic').iCheck('uncheck');
							}
						}
						else if (key==="llegendaoberta"){
							if(value === 1){
								$('.llegenda-subrow input#visor-chck-oberta').iCheck('check');
							}else{
								$('.llegenda-subrow input#visor-chck-oberta').iCheck('uncheck');
							}
						}
						else {
							var selector = '.visor-subrow[data-param="'+key+'"]';
							var elem = $(selector).find('.visor-chck');
							if(value === 1){
								elem.iCheck('check');
							}else{
								elem.iCheck('uncheck');
							}
						}
					});					
        		}
        		if(!$.isEmptyObject(params.iframe)){
        			var iframe = params.iframe;
        			$.each(iframe, function(key, value){
						if (key==="legendControl"){
							if(value === 1){
								$('.llegenda-subrow input#iframe-chck-compacta').iCheck('check');
							}else{
								$('.llegenda-subrow input#iframe-chck-compacta').iCheck('uncheck');
							}
						}
						else if (key==="llegendadinamica"){
							if(value === 1){
								$('.llegenda-subrow input#iframe-chck-dinamica').iCheck('check');
							}else{
								$('.llegenda-subrow input#iframe-chck-dinamica').iCheck('uncheck');
							}
						}
						else if (key==="llegendaoberta"){
							if(value === 1){
								$('.llegenda-subrow input#iframe-chck-oberta').iCheck('check');
							}else{
								$('.llegenda-subrow input#iframe-chck-oberta').iCheck('uncheck');
							}
						}
						else {
							var selector = '.visor-subrow[data-param="'+key+'"]';
							var elem = $(selector).find('.iframe-chck');
							if(value === 1){
								elem.iCheck('check');
							}else{
								elem.iCheck('uncheck');
							}
						}
        			});
        		}
        	}
        },

        //********* Nova funcio per crear WMS*************//
        createWMSFromMap:function(){
        	var data=getCapesVectorActives();

        	data.request="createWMSfromMap";
            data.entitatUid=_UsrID,
            data.businessId=mapConfig.businessId;
            data.nomAplicacio=mapConfig.nomAplicacio;
            data.modeMapa=InstamapsUtils.Validator.isModeMapa($(location).attr('href'));

            createMapToWMS(data).then(

            function(results) {
            	if (results.status == "OK") {
            		$('#div_urlMapWMS').show();
                    $('#urlMapWMS').val(results.url);
                }else if (results.status == "VOID") {
                	$('#div_urlMapWMS').hide();
                }else{
                    $('#div_urlMapWMS').hide();
                    $('#urlMapWMS').val(results.msg);
                }
        	});
        },
        /**********Events**************/

        bindEvents: function(){
        	//$.publish('galeria/load',{mas:1,del:"asdasdasd"});
        },

        subscriptions: function() {
        	var self = this;
        	$.subscribe('publicar/loadMapConfig',function(e, data){
        		self._setMapConfig(data);
        		self._updateModalPublicar();
        	});

        	$.subscribe('publicar/setMap',function(e, data){
        		$.when.apply(null, runningActions).done(function() {
					self._setMap(data);
					self._publicarMapa();
        		});
        	});

        	//Here is where the Observer Pattern kicks in nicely
            //I'm done with the listeners, and I'm letting everyone that is subscribed know that.
            //You can also namespace easily with "/" like so: ("enable/Select") or ("enable/Move") etc.
            $.publish( "listeners/are/set/up" );
        }
   	}

   	//Registre module if AMD is present:
   	if(typeof define === "function" && define.amd){
   		define([], function(){return Publicar.init();} );
   	}

   	//Initialize the whole thing. Can be referenced anywhere in your code after it has been declared.
   	window.Publicar = Publicar.init();
})( jQuery, window, document );

